export function safeJSONParse(key, fallback = null) {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return fallback;
        return JSON.parse(raw);
    } catch (e) {
        console.warn(`Ошибка парсинга localStorage ключа "${key}":`, e);
        localStorage.removeItem(key); // удаляем битые данные
        return fallback;
    }
}
